'use client'

import { Profiler, useEffect, useState, type ProfilerOnRenderCallback, type ReactNode } from 'react'
import { recordRender, isEnabled as isPerfEnabled } from '@/lib/perf'

const onRender: ProfilerOnRenderCallback = (
  id,
  phase,
  actualDuration,
  baseDuration,
  startTime,
  commitTime,
) => {
  recordRender(id, phase, actualDuration, baseDuration, startTime, commitTime)
}

export default function PerfProfiler({ id, children }: { id: string; children: ReactNode }) {
  // Opt-in only: keep React's <Profiler> unmounted unless perf is explicitly enabled
  // (?perf=1 / localStorage.__PERF__ / NEXT_PUBLIC_PERF=1). This restores perf.ts's
  // "no-op unless enabled" contract and sidesteps a React 19 Profiler commit-phase bug
  // ("Cannot set properties of null (setting 'effectDuration')") that fires when a
  // Profiler wraps Suspense boundaries. isEnabled() is client-only, so flip after mount
  // to avoid an SSR/hydration mismatch.
  const [enabled, setEnabled] = useState(false)
  useEffect(() => {
    setEnabled(isPerfEnabled())
  }, [])

  if (!enabled) return children

  return (
    <Profiler id={id} onRender={onRender}>
      {children}
    </Profiler>
  )
}
